import "bootstrap";

import { enableMapSet } from "immer";
import React from "react";
import { createRoot } from "react-dom/client";
import submitButton from "utils/submitButton";
import initAdmin from "widgets/AdminViewEnhancers";
import initCategoryEditor from "widgets/CategoryEditor";

import { App } from "~/App";

enableMapSet();

function init() {
  // IE fix
  HTMLCollection.prototype.forEach = Array.prototype.forEach;
  NodeList.prototype.forEach = Array.prototype.forEach;

  submitButton();

  // Initialize Mixpanel
  if (DJ_CONST.user) {
    if (DJ_CONST.user.is_hijacked_user) {
      mixpanel.disable();
    }

    mixpanel.identify(DJ_CONST.user.id);
    mixpanel.people.set({
      $email: DJ_CONST.user.email,
      $phone: DJ_CONST.user.phone_number,
      $first_name: DJ_CONST.user.first_name,
      $last_name: DJ_CONST.user.last_name,
      $created: DJ_CONST.user.date_joined,
      "Is Staff": DJ_CONST.user.is_staff,
      Company: DJ_CONST.user.company,
    });
  }
}

function initApp() {
  createRoot(document.getElementById("app")).render(<App />);
}

export { init, initApp, initAdmin, initCategoryEditor };
